import { pathOr, head, find, propEq, toLower } from "ramda";
import { LABELS, OBJECT_META } from "src/services/constants";
import { getTheResourceByAccountId } from "src/utilities/borrowers";
import { isNotEmpty, pathIsNotEmpty } from "src/utilities/hasValue";
import { unAuthenticatedUser } from "src/utilities/storage";
import { mapIndexed } from "src/utilities/visualFieldsMapper";

export class LoanAppsLoader {
    loanId: string;
    accountId: string;
    loanApps: any;
    constructor(loanId: string, accountId: string, loanApps: any,) {
        this.loanId = loanId;
        this.accountId = accountId;
        this.loanApps = loanApps;
    }

    getLoanApps() {
        const accountLoans = pathOr([], ['loanapp_roles'], this.loanApps);
        const declarations = pathOr([], ['declarations'], this.loanApps);
        if (isNotEmpty(accountLoans)) {
            // make loan app json like application information page
            return mapIndexed((item: any) => {
                const loanapp = pathOr({}, ['loanapp'], item);
                const loanRoles = pathOr([], ['loanapp_roles'], loanapp)
                const loanRole = head(getTheResourceByAccountId(loanRoles, this.accountId));
                return {
                    id: pathOr('', ['id'], loanapp),
                    type_of_loan: pathOr('', ['type_of_loan'], loanapp),
                    sub_type_of_loan: pathOr('', ['sub_type_of_loan'], loanapp),
                    created_at: pathOr('', ['created_at'], loanapp),
                    spec: {
                        borrowers: getTheResourceByAccountId(pathOr([], ['borrowers'], loanRole), this.accountId),
                        business: getTheResourceByAccountId(pathOr([], ['businesses'], loanRole), this.accountId),
                        lending_terms: pathOr({}, ['lending_terms', 0], find(pathIsNotEmpty(['lending_terms', 0]), loanRoles)),
                        property: pathOr({}, ['properties', 0], loanapp),
                        loanapp_roles: [loanRole],
                        loan_status: pathOr([], ['loan_statuses'], find(pathIsNotEmpty(['loan_statuses', 0]), loanRoles)),
                        declarations: getTheResourceByAccountId(declarations, this.accountId),
                    },
                };
            }, accountLoans);
        }
        return [];
    }

    getLoanAppById() {
        return find(propEq('id', this.loanId))(this.loanApps);
    }

    setLoanDetailsInSession() {
        const propertyType = pathOr('', ['spec', 'property', OBJECT_META, LABELS, 'property_loan_type'], this.getLoanAppById())
        unAuthenticatedUser.aliasName.set(toLower(pathOr('', ['type_of_loan'], this.getLoanAppById())));
        unAuthenticatedUser.productType.set(propertyType);
    }
}
